import { push } from 'react-router-redux'
import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'

// Action
export const REDIRECT_TO_NOT_FOUND = 'REDIRECT_TO_NOT_FOUND'

// Action Helper
export const redirectToNotFound = (notFoundType) => ({ type: REDIRECT_TO_NOT_FOUND, payload: notFoundType })

// Epic
export const redirectToNotFoundEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(REDIRECT_TO_NOT_FOUND),
    map(action => {
      return push(`/notFound/${action.payload}`)
    })
  )



// WEBPACK FOOTER //
// ./src/store/redirectToNotFound.js